<template>
    <div v-if="hasError" class="ctw-w-full ctw-bg-white6 ctw-text-white ctw-px-6 ctw-py-4">
                Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.
                <button class="ctw-bg-blue-400 ctw-text-blue-800 ctw-border ctw-border-blue-900 ctw-border-1 ctw-font-medium ctw-rounded ctw-mt-4 ctw-px-4 ctw-py-2 hover:ctw-bg-blue-600 hover:ctw-text-white" @click="retryResponse">
                    Erneut versuchen
                </button>
            </div>
</template>

<script setup>
import { computed } from 'vue';
import { useConversationStore } from '@/store/conversation';

const conversationStore = useConversationStore();

const hasError = computed(() => conversationStore.hasError);

const retryResponse = () => conversationStore.retryResponse();

</script>